/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minifier_IntroInputs */

const en_minifier_intro = /** @type {(inputs: Minifier_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strip every byte of insignificant whitespace from JSON and see exactly how much you saved. The output parses to the same values as the input.`)
};

const ko_minifier_intro = /** @type {(inputs: Minifier_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON에서 의미 없는 공백을 한 바이트도 남기지 않고 제거하고, 얼마나 줄었는지 정확히 확인합니다. 출력은 입력과 같은 값으로 파싱됩니다.`)
};

const ja_minifier_intro = /** @type {(inputs: Minifier_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON から意味のない空白を 1 バイトも残さず取り除き、どれだけ減ったかを正確に確認します。出力は入力と同じ値にパースされます。`)
};

/**
* | output |
* | --- |
* | "Strip every byte of insignificant whitespace from JSON and see exactly how much you saved. The output parses to the same values as the input." |
*
* @param {Minifier_IntroInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const minifier_intro = /** @type {((inputs?: Minifier_IntroInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minifier_IntroInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minifier_intro(inputs)
	if (locale === "ko") return ko_minifier_intro(inputs)
	return ja_minifier_intro(inputs)
});